import { useEffect, useState } from 'preact/hooks';
import { apiFetch } from '../api/client';
import { ReconnectSquare } from './ReconnectSquare';
import { ASSISTANT_NAME } from '../brand.js';

export function CardPermissions({ salonId }) {
  const [status, setStatus] = useState('loading');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let alive = true;
    let generation = 0;
    let controller;
    async function inspect() {
      const current = ++generation;
      controller?.abort();
      controller = new AbortController();
      setStatus('loading');
      try {
        const result = await apiFetch('/account/dashboard', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'inspect_card_permissions' }), signal: controller.signal,
        });
        if (alive && current === generation) {
          setStatus(['allowed', 'needs_consent', 'read_only', 'unavailable'].includes(result?.status)
            ? result.status : 'unavailable');
        }
      } catch {
        if (alive && current === generation) setStatus('unavailable');
      }
    }
    inspect();
    window.addEventListener('focus', inspect);
    window.addEventListener('pageshow', inspect);
    return () => {
      alive = false;
      controller?.abort();
      window.removeEventListener('focus', inspect);
      window.removeEventListener('pageshow', inspect);
    };
  }, [salonId, revision]);

  return <section aria-label="Secure card storage" style={{ padding: '1rem', borderBottom: '1px solid var(--border-subtle)' }}>
    <h3 style={{ margin: '0 0 0.5rem', fontSize: '1rem' }}>Cards on file</h3>
    <p style={{ margin: '0 0 0.75rem', color: 'var(--text-secondary)' }}>
      Square keeps cards on file for your salon. Approving access here does not charge a deposit or cancellation fee.
    </p>
    <div role="status" aria-live="polite">
      {status === 'loading' && 'Checking your Square permissions…'}
      {status === 'allowed' && 'Square has granted permission to save cards.'}
      {status === 'needs_consent' && `One more approval in Square lets ${ASSISTANT_NAME} save cards for your salon.`}
      {status === 'read_only' && 'Changes to this Square account are paused. Card storage is unavailable while it is read-only.'}
      {status === 'unavailable' && 'We couldn’t check your Square connection. Try again, or reconnect Square below.'}
    </div>
    {status === 'needs_consent' && <ReconnectSquare guided cardStorage label="Allow secure card storage" />}
    {status === 'unavailable' && <button type="button" onClick={() => setRevision(value => value + 1)} style={{ minHeight: '44px', marginTop: '0.75rem', padding: '0.5rem 1rem', font: 'inherit' }}>Check again</button>}
  </section>;
}
